import CompaniesDashboard from "./CompaniesDashboard";

export default CompaniesDashboard;
